<template>
    <vx-card>
        <div class="vx-card " id="ss-results-step">

            <div class="vx-row modify-div mt-5" >
                <div class="vx-col chart" v-if="temporaryDisability">
                    <div class="w-full">
                        <generic-donut-chart
                            v-bind:seriesData="[temporaryDisability.socialSecurity, temporaryDisability.complemented, temporaryDisability.notCovered]"
                            v-bind:name="temporaryDisability.name"
                            v-bind:commercialOfferType="commercialOffer.type"
                            v-bind:percentage="temporaryDisability.percentage"
                            v-bind:percentageCategory="temporaryDisability.percentageCategory"
                            v-bind:infoButton="'Cuando estás imposibilitado temporalmente para trabajar y recibes asistencia sanitaria de la Seguridad Social.'"
                            >
                        </generic-donut-chart>                                
                    </div>
                </div>

                <div class="vx-col chart" v-if="totalPermanentDisability">
                    <div class="w-full">
                        <generic-donut-chart
                            v-bind:seriesData="[totalPermanentDisability.socialSecurity, totalPermanentDisability.complemented, totalPermanentDisability.notCovered]"
                            v-bind:name="totalPermanentDisability.name"
                            v-bind:commercialOfferType="commercialOffer.type"
                            v-bind:percentage="totalPermanentDisability.percentage"
                            v-bind:percentageCategory="totalPermanentDisability.percentageCategory"
                            v-bind:infoButton="'Cuando una enfermedad o un accidente te inhabilita para tu profesión habitual, pero puedes dedicarte a otra distinta.'"
                            >
                        </generic-donut-chart>
                    </div>
                </div>

                <div class="vx-col chart" v-if="absolutePermanentDisability">
                    <div class="w-full">
                        <generic-donut-chart
                            v-bind:seriesData="[absolutePermanentDisability.socialSecurity, absolutePermanentDisability.complemented, absolutePermanentDisability.notCovered]"
                            v-bind:name="absolutePermanentDisability.name"
                            v-bind:commercialOfferType="commercialOffer.type"
                            v-bind:percentage="absolutePermanentDisability.percentage"
                            v-bind:percentageCategory="absolutePermanentDisability.percentageCategory"
                            v-bind:infoButton="'Cuando una enfermedad o un accidente te inhabilita para toda profesión u oficio.'"
                            >
                        </generic-donut-chart>
                    </div>
                </div>

                <div class="vx-col chart" v-if="greatDisability">
                    <div class="w-full">
                        <generic-donut-chart
                            v-bind:seriesData="[greatDisability.socialSecurity, greatDisability.complemented, greatDisability.notCovered]"
                            v-bind:name="greatDisability.name"
                            v-bind:commercialOfferType="commercialOffer.type"
                            v-bind:percentage="greatDisability.percentage"
                            v-bind:percentageCategory="greatDisability.percentageCategory"
                            v-bind:infoButton="'Cuando estás incapacitado permanentemente y necesitas la asistencia de otra persona para los actos más esenciales de la vida.'"
                            >
                        </generic-donut-chart>
                    </div>
                </div>

                <div class="vx-col chart" v-if="widowhood">
                    <div class="w-full">
                        <generic-donut-chart
                            v-bind:seriesData="[widowhood.socialSecurity, widowhood.complemented, widowhood.notCovered]"
                            v-bind:name="widowhood.name"
                            v-bind:commercialOfferType="commercialOffer.type"
                            v-bind:percentage="widowhood.percentage"
                            v-bind:percentageCategory="widowhood.percentageCategory"
                            v-bind:infoButton="'Si se produce el fallecimiento, pensión que percibirán las personas que hayan tenido contigo vínculo matrimonial o sido pareja de hecho y no hayan contraído nuevo matrimonio.'"
                            >
                        </generic-donut-chart>
                    </div>
                </div>

                <div class="vx-col chart" v-if="orphanhood">
                    <div class="w-full" >
                        <generic-donut-chart
                            v-bind:seriesData="[orphanhood.socialSecurity, orphanhood.complemented, orphanhood.notCovered]"
                            v-bind:name="orphanhood.name"
                            v-bind:commercialOfferType="commercialOffer.type"
                            v-bind:percentage="orphanhood.percentage"
                            v-bind:percentageCategory="orphanhood.percentageCategory"
                            v-bind:infoButton="'Si se produce el fallecimiento, pensión que percibirán tus hijos, y los aportados por el cónyuge, que reúnan los requisitos exigidos.'"
                            >
                        </generic-donut-chart>
                    </div>
                </div>

            </div>


            <div class="vx-row legend mb-10 mt-10" style="padding:0px" >
                <div class="vx-col legend-label" style="display:flex">
                    <div class="box green"></div>
                    <label>Cobertura Seguridad Social</label>
                </div>
                <div class="vx-col legend-label" style="display:flex">
                    <div class="box blue"></div>
                    <label>Cobertura adicional con seguro privado</label>
                </div>
                <div class="vx-col legend-label" style="display:flex">
                    <div class="box red"></div>
                    <label>Ingresos sin cobertura</label>
                </div>
            </div>

            <navegation-buttons id="buttons"
                v-bind:code="code"
                v-bind:previus="previus">
            </navegation-buttons>
            
            <!--             
            <vs-popup  class="con-vs-popup bg-box-gradient-popup"  title="¿Hablamos?" :active.sync="callServicePopup">
                <call-service-popup
                    v-bind:callServicePopup="callServicePopup"
                    v-bind:callServiceType="callServiceType"
                    @closeCallServicePopup="closeCallServicePopup"
                >
                </call-service-popup>
            </vs-popup>

            <div id="buttons" class="form-width" style="display:flow-root">
            
                <div class="box-buttons  ">
                    <div class="back-button no-fill-button">
                        <vs-button
                        class="vs-button previous-product "
                        @click="goToCovers()"
                        >
                        Anterior
                        </vs-button>
                    </div>
                    <div class="call-button no-fill-button">
                        <vs-button
                            @click="callService()"
                        >
                        <img src="../../../../assets/images/logo/call-phone-icon.png" width="15px" height="15px"/>
                            Solicitar llamada
                        </vs-button>
                    </div>
                </div>
            </div> -->

        </div>
    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
// import CoverageChartComponent from '../coverage-chart/CoverageChartComponent.vue'
// import DonutChart from '../donut-chart/DonutChart.vue'
import GenericDonutChart from '../generic-donut-chart/GenericDonutChart.vue'
import NavegationButtons from '../navegationButtons/NavegationButtons.vue'
import vSelect from 'vue-select'

// import CallServicePopup from '../../../components/eprevision-components/callServicePopup/CallServicePopup.vue';


export default {
  components: { 
      VxCard,
    //   CoverageChartComponent,
      NavegationButtons,
    //   CallServicePopup ,
      vSelect, 
      ApexCharts, 
    //   DonutChart, 
      GenericDonutChart},

    name: 'commercial-offer-social-security',
    props: {
        commercialOffer: Object,
        clientsNeeds: Object,
        reverseData: Object,
        code: String,
        previus: String,
    },
    data() {
        return {
            clientsCapitals: null,
            // callServiceType:"helpProcess",
            // callServicePopup: false,

            absolutePermanentDisability: null,
            temporaryDisability: null,
            greatDisability: null,
            totalPermanentDisability: null,
            orphanhood: null,
            widowhood: null,

            salaryMonth: 0,
        }
    },
    created() {
        this.clientsCapitals = this.clientsNeeds.clientsCapitals
        this.salaryMonth = this.clientsNeeds.salaryMonth
        
        this.initForm();

    },
    methods: {
        initForm() {

            this.clientsCapitals.forEach(clientsCapital => {
                
                if (clientsCapital.bool == true){
                    
                    let data = {
                        name:"",
                        socialSecurity: 0,
                        complemented: 0,
                        notCovered: 0,
                        percentage: 0,
                        percentageCategory: "withCover",
                    }

                    data.socialSecurity = clientsCapital.social
                    data.name = clientsCapital.name

                    if (clientsCapital.name == "Incapacidad Permanente Absoluta") {
                        if(this.reverseData.absolutPermanentDisability) {  
                            data.complemented = this.reverseData.absolutPermanentDisability
                        } else {
                            data.complemented = 0
                        }

                        data.notCovered = this.salaryMonth - (data.socialSecurity + data.complemented)
                        data.percentage = ((data.socialSecurity + data.complemented)/this.salaryMonth)*100

                        this.absolutePermanentDisability = data

                    } else if (clientsCapital.name == "Incapacidad Permanente Total") {
                        if(this.reverseData.totalPermanentDisability) {  
                            data.complemented = this.reverseData.totalPermanentDisability
                        } else {
                            data.complemented = 0
                        }
    
                        data.notCovered = this.salaryMonth - (data.socialSecurity + data.complemented)
                        data.percentage = ((data.socialSecurity + data.complemented)/this.salaryMonth)*100
                        
                        this.totalPermanentDisability = data

                    } else if (clientsCapital.name == "Gran Invalidez") {
                        if(this.reverseData.absolutPermanentDisability) {  
                            data.complemented = this.reverseData.absolutPermanentDisability
                        } else {
                            data.complemented = 0
                        }

                        data.notCovered = this.salaryMonth - (data.socialSecurity + data.complemented)
                        data.percentage = ((data.socialSecurity + data.complemented)/this.salaryMonth)*100

                        this.greatDisability = data

                    } else if (clientsCapital.name == "Incapacidad Temporal") {
                        if(this.reverseData.temporaryDisability) {  
                            data.complemented = this.reverseData.temporaryDisability
                        } else {
                            data.complemented = 0
                        }
                        data.notCovered = this.salaryMonth - (data.socialSecurity + data.complemented)
                        data.percentage = ((data.socialSecurity + data.complemented)/this.salaryMonth)*100

                        this.temporaryDisability = data

                    } else if (clientsCapital.name == "Viudedad") {
                        if(this.reverseData.widowhood) {  
                            data.complemented = this.reverseData.widowhood
                        } else {
                            data.complemented = 0
                        }
                        data.notCovered = this.salaryMonth*0.52 - (data.socialSecurity + data.complemented)
                        data.percentage = ((data.socialSecurity + data.complemented)/(this.salaryMonth*0.52))*100

                        this.widowhood  = data

                    } else if (clientsCapital.name == "Orfandad"){
                        if(this.reverseData.orphanhood) {  
                            data.complemented = this.reverseData.orphanhood
                        } else {
                            data.complemented = 0
                        }
                        data.notCovered = this.salaryMonth*0.48 - (data.socialSecurity + data.complemented)
                        data.percentage = ((data.socialSecurity + data.complemented)/(this.salaryMonth*0.48))*100

                        this.orphanhood = data
                    }
                } else {
                                        
                    let data = {
                        name:"",
                        socialSecurity: 0,
                        complemented: 0,
                        notCovered: 0,
                        percentage: 0,
                        percentageCategory: "withCover",
                    }

                    data.socialSecurity = clientsCapital.social
                    data.name = clientsCapital.name
                    data.notCovered = this.salaryMonth - (data.socialSecurity + data.complemented)
                    data.percentage = ((data.socialSecurity + data.complemented)/this.salaryMonth)*100


                    if (clientsCapital.name == "Incapacidad Permanente Absoluta") {
                        this.absolutePermanentDisability = data

                    } else if (clientsCapital.name == "Incapacidad Permanente Total") {
                        this.totalPermanentDisability = data

                    } else if (clientsCapital.name == "Gran Invalidez") {
                        this.greatDisability = data

                    } else if (clientsCapital.name == "Incapacidad Temporal") {
                        this.temporaryDisability = data

                    } else if (clientsCapital.name == "Viudedad") {
                        data.notCovered = this.salaryMonth*0.52 - (data.socialSecurity + data.complemented)
                        // data.percentage = (((this.salaryMonth*0.52) - data.socialSecurity) / (this.salaryMonth*0.52))*100
                        data.percentage = ((data.socialSecurity + data.complemented)/(this.salaryMonth*0.52))*100

                        this.widowhood  = data

                    } else if (clientsCapital.name == "Orfandad"){
                        data.notCovered = this.salaryMonth*0.48 - (data.socialSecurity + data.complemented)
                        // data.percentage = (((this.salaryMonth*0.48) - data.socialSecurity) / (this.salaryMonth*0.48))*100
                        data.percentage = ((data.socialSecurity + data.complemented)/(this.salaryMonth*0.48))*100

                        this.orphanhood = data
                    }
                }
            })

        },

        // callService() {
        //     this.callServicePopup = true;
        // },

        // closeCallServicePopup(value){
        //     this.callServicePopup = value;
        // },

        goToCovers() {

            this.$router
            .push("/"+ this.previus + "-step/" + this.code)
            .catch(() => {});

        },

    },
    


    }

</script>
<style lang="scss">

#ss-results-step {
    // .box-buttons{
    //     .back-button{

    //         padding-bottom: 20px;
    //     }
    // }
    .legend{
        display: flex !important;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: center;
        justify-content: space-evenly;
        align-items: center;
    }

    .box{
        min-height:20px !important;
        min-width: 20px !important;
        height:20px !important;
        width: 20px !important;
        margin-right: 3px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;

    }


    // .blue {
    //     background-color: rgba(var(--vs-secundary), 1);
    // }

    // .red {
    //     background-color: #F34336;
    // }

    // .green {
    //     background-color: #28C76F;
    // }

    .modify-div {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        align-content: stretch;
        justify-content: center;
        align-items: stretch;
    }

    

    .image {
        width: 60px;
        height: 60px;
        display:block;
        margin:auto;
    }


    @media screen and (max-width: 490px) {   
        .legend{
            display: flex !important;
            flex-wrap: nowrap;
            flex-direction: column;
            align-content: flex-start;
            justify-content: space-evenly;
            align-items: flex-start;

            .legend-label{
                padding-top: 5px;
                text-align:left;
            }
        }
    }
    
    
    @media screen and (min-width : 491px)
      and (max-width : 600px) {  
        .chart{
            width: 100% !important;
            margin: 0;
        }
        
        .call-button{
            .vs-button{
                float: center !important;
            }
        }

    }
    @media screen and (min-width : 601px)
      and (max-width : 799px) {     

        .chart{
            width: 100% !important;
            margin: 0;
        }

        .call-button{
            .vs-button{
                float: right !important;
            }
        }

    }

    @media only screen and (min-width : 800px)
  and (max-width : 1110px) {

        .chart{
            width: 50% !important;
            margin: 0;
        }
        .call-button{
            .vs-button{
                float: right !important;
            }
        }
    }

    @media screen and (min-width: 1101px) {

        .chart{
            width: 33% !important;
            margin: 0;
        }
        .call-button{
            .vs-button{
                float: right !important;
            }
        }
    }
}
</style>